module.exports = __webpack_public_path__ + "c772f283f5c7eda831db879379222ab0.jpg";